import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DoctorWrapper from '../TeacherWrapper';
import Input from '../../components/Input';
import { toast } from 'react-toastify';
import moment from 'moment';

const DoctorCources = () => {
  const [open, setOpen] = useState(false);
  const [mytotalCourse, setTotalCourse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [completed, setCompleted] = useState();

  const [cources, setCourse] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');

  const [teacherId, setTeacherId] = useState('');
  useEffect(() => {
    const storedAdminData = localStorage.getItem('userData');
    if (storedAdminData) {
      const admin = JSON.parse(storedAdminData);
      setTeacherId(admin?._id);
    } else {
      console.log('No admin data found in local storage.');
    }
  }, []);

  const filteredCourses = mytotalCourse.filter((course) => {
    const matchesSearchQuery =
      course?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      course?.course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/my-course/${data?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (!result.success) {
          setError(result.message || 'No valid courses found for this teacher');
          setTotalCourse([]);
        } else {
          setTotalCourse(result.data || []);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        setError('Failed to load courses');
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/count-students/${teacherId}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log(data?.data?.completed);
        setCompleted(data?.data);
      })
      .catch((error) => console.error(error));
  }, [teacherId]);

  const fetchTeachers = () => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    setLoading(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/teacher/my-completed-students/${data?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        
        setTeachers(result?.data);
        setTotalPages(result?.data?.totalPages || Math.ceil(result?.data?.totalStudents / 6) || 1);
        setLoading(false);
      })
      .catch((error) => {
        toast.error('Failed to fetch teachers');
        setLoading(false);
      });
    
  };

  useEffect(() => {
    fetchTeachers();
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCourse(data?.courses);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  }, []);


  const [tabs, setTabs] = useState('cources');

  return (
    <DoctorWrapper
      searchBar={
        <Input
          placeholder={`Search by course name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <div className="flex justify-between items-center">
        <div>
          <h2 className="main_title">Cources</h2>
          <p className="text-[#1C1D1D]">Here overview of the courses</p>
        </div>
        <div></div>
      </div>

      <section className="pt-2">
        <div className="py-4 w-full grid grid-cols-1 xl:grid-cols-3 md:grid-cols-2 gap-5">
          <div onClick={() => setTabs('completed')} className="w-full cursor-pointer">
            <div
              className="bg-white p-5 rounded-lg flex justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className="text-[#1C1D1D] text-[20px] font-semibold">Completed</h2>
                <div className="pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-[#1C1D1D]">{teachers?.length}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/active.png')} alt="" />
              </div>
            </div>
          </div>
          <div onClick={() => setTabs('cources')} className="w-full  cursor-pointer">
            <div
              className="bg-white flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className="text-[#1C1D1D] text-[20px] font-semibold">Ongoing</h2>
                <div className="pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{mytotalCourse?.length}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
          <div onClick={() => setTabs('totalCources')} className="w-full cursor-pointer">
            <div
              className="bg-white text-black flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className="text-[#1C1D1D] text-[20px] font-semibold">Total Cources</h2>
                <div className="pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{cources?.length}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/ongoing.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {tabs === 'completed' && (
        <section className="mb-20 mt-7">
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          <th className="text-sm text-primary font-bold px-6 py-4">Sr No.</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">ID</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Name</th>
                          {/* <th className="text-sm text-primary font-bold px-6 py-4">Phone no</th> */}
                          <th className="text-sm text-primary font-bold px-6 py-4">Country</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Timing</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Course Name</th>
                          {/* <th className="text-sm text-primary font-bold px-6 py-4">Payment</th> */}
                          <th className="text-sm text-primary font-bold px-6 py-4">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {teachers.map((teacher, index) => {
                          return (
                            <tr key={teacher?._id} className="bg-white shadow-lg mt-6 rounded-lg">
                              <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                  {index + 1}
                                </span>
                              </td>
                              
                              <td className="align-middle whitespace-nowrap bg-white text-sm font-normal px-6 py-4 text-center">
                                <span className="text-base text-black py-1 px-2.5 bg-green-200 rounded-full">
                                  {teacher?.enrollment?.userDetails?.studentId}
                                </span>
                              </td>
                              <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                  {teacher?.enrollment?.userDetails?.name}
                                </span>
                              </td>
                            
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.enrollment?.userDetails?.country}
                                </span>
                              </td>
                             
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                {teacher?.timeSlots?.map((item, index) => (
                                  <div key={index}>
                                    {item?.startTime} - {item?.endTime}
                                  </div>
                                ))}
                              </td>
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.enrollment?.courseName}
                                </span>
                              </td>
                        
                              <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                               
                                  <span
                                    className={`text-base py-1 px-2.5 leading-none whitespace-nowrap rounded-md ${
                                      teacher?.enrollment?.status === 'pending'
                                        ? 'bg-[#FFF3E0] text-[#FFA500]'
                                        : teacher?.enrollment?.status === 'completed'
                                          ? 'bg-[#FFE4E4] text-[#FF0000]'
                                          : teacher?.enrollment?.status === 'approved'
                                            ? ' bg-[#DFF7E3] text-[#23A118]'
                                            : teacher?.enrollment?.status === 'inactive'
                                              ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                              : 'bg-gray-200 text-black'
                                    }`}
                                  >
                                    {teacher?.enrollment?.status}
                                  </span>
                                
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end mt-4 items-center">
  <button
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Previous
  </button>
  
  <span className="mx-4 py-2">
    Page {currentPage} of {totalPages}
  </span>
  
  <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    className="mx-2 px-3 py-2 border rounded bg-white"
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <option key={page} value={page}>
        {page}
      </option>
    ))}
  </select>
  
  <button
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
    className="px-4 py-2 bg-gray-200 text-gray-700 cursor-pointer rounded hover:bg-gray-300"
  >
    Next
  </button>
</div>
        </section>
      )}

      {tabs === 'cources' &&
        (loading ? (
          <p>Loading courses...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <section>
            {mytotalCourse?.length === 0 ? (
              <p>No courses available</p>
            ) : (
              <div className="grid grid-cols-2 mt-4 gap-6">
                {filteredCourses?.map((course) => (
                  <Link
                    to={`/teacher-cource-details/${course?._id}`}
                    className="bg-white p-5 items-center flex md:flex-row flex-col rounded-lg gap-4"
                    style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                    key={course?._id}
                  >
                    <div className="w-20 h-20 rounded-lg overflow-hidden">
                      <img src={course?.image} className="w-full h-full" alt={course?.name} />
                    </div>
                    <div>
                      <h6 className="text-lg flex gap-3">
                        {course?.name}{' '}
                        <img src={require('../../assets/image/LockSimple.png')} alt="" />
                      </h6>
                      <div className="flex gap-5 pt-2 items-center">
                        <div className="flex gap-1 items-center">
                          <div>
                            <img src={require('../../assets/image/Clock.png')} alt="" />
                          </div>
                          <p>
                            {course?.duration} {course?.periodType}
                          </p>
                        </div>

                        <div className="flex gap-1 items-center">
                          <p>
                            Status : <span className="text-sm text-[green]">Active</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </section>
        ))}

      {tabs === 'totalCources' &&
        cources.map((course) => (
          <div className=" grid grid-cols-1 mt-4 gap-6" key={course._id}>
            <Link
              to={`/single-cources-details/${course?._id}`}
              className=" bg-white flex md:flex-row flex-col  rounded-lg gap-4"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div className="md:w-3/12 w-12/12">
                <img src={course?.image} className="w-full h-64 object-cover rounded-lg" alt="" />
              </div>

              <div className=" md:w-8/12 w-12/12 p-4">
                <h6 className=" pt-3 text-lg">{course?.name}</h6>
                <div className=" flex gap-5 pt-2  items-center">
                  <div className=" flex gap-1 items-center">
                    <div>
                      <img src={require('../../assets/image/Form.png')} alt="" />
                    </div>
                    <p>{course?.lesson} Lesson</p>
                  </div>

                  <div className=" flex gap-1 items-center">
                    <div>
                      <img src={require('../../assets/image/Graduation Cap.png')} alt="" />
                    </div>

                    <p>{course?.duration}</p>
                    <p>{course?.periodType}</p>
                  </div>
                </div>
                <p className=" pt-2 text-sm">{course?.description}</p>
                <div className=" flex items-center gap-2 pt-3">
                  <img src={require('../../assets/image/Form.png')} alt="" />

                  <p>121 Students</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
    </DoctorWrapper>
  );
};

export default DoctorCources;
